const showLoader = (loading, networkStatus, data, refetching = false) => {
  return  ((loading && [1, 2].includes(networkStatus)) && !data) || refetching;
}

export default showLoader

 